import { useContext } from "react";

import { OrganizationsContext } from "@/contexts/organizations";

export default function useFeatures() {
  const { features } = useContext(OrganizationsContext);
  return features;
}
